import { render, staticRenderFns } from "./AddApplicationQuestionDialog.vue?vue&type=template&id=52bd45b6&"
import script from "./AddApplicationQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./AddApplicationQuestionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports